import { useQuery } from '@tanstack/react-query';
import { authEntity } from '@/data';
import { useToken } from '@/hooks';
import type { IRoles, IUser } from '@/types';

export function useUserQuery() {
    const token = useToken();
    return useQuery<IUser, Error>({
        queryKey: authEntity.fetchers.user.key(),
        queryFn: authEntity.fetchers.user.fetch,
        enabled: token.length > 0,
    });
}

export function useRolesQuery() {
    return useQuery<IRoles, Error>({
        queryKey: authEntity.fetchers.roles.key(),
        queryFn: authEntity.fetchers.roles.fetch,
    });
}
